import '../styles.scss'
import React from 'react'
import { I18n } from 'react-redux-i18n'

import { Button } from 'components/Form'
import AlternativesModal from '../../Views/Processes/ProcessContent/AlternativesModal'
import { getStaticImage } from 'utils/statics'

const AlternativesUI = ({ isRequired, label, alternativesId, fromAlternativesId, value, isOpenAlternativesModal, toggleAlternativesModal, error }) => (
  <div className={`smartchat-field alternatives ${error ? 'alternatives--error' : ''}`}>
    {label && (
      <div className='smartchat-field__header'>
        {label && <label>{label}</label>}
        <span>{isRequired ? `(${I18n.t('dashboard_required')})` : `(${I18n.t('dashboard_optional')})`}</span>
      </div>
    )}
    <div className='smartchat-field__body'>
      <Button
        clearPrimary
        icon={
          <figure>
            <img
              src={!value ? getStaticImage('/icons/orange-brand/add-circle-icon-primary.svg') : getStaticImage('/icons/orange-brand/icon-edit-primary.svg')}
              alt={!value ? I18n.t('smartchat_alternativesMessage_create') : I18n.t('smartchat_alternativesMessage_edit')}
            />
          </figure>
        }
        value={!value ? I18n.t('smartchat_alternativesMessage_create') : I18n.t('smartchat_alternativesMessage_edit')}
        onClick={toggleAlternativesModal}
      />
      {isOpenAlternativesModal && alternativesId && (
        <AlternativesModal
          isOpen={isOpenAlternativesModal}
          toggle={toggleAlternativesModal}
          alternativesId={alternativesId}
          fromAlternativesId={fromAlternativesId}
        />
      )}
    </div>
  </div>
)

export default AlternativesUI
